import { GenerationJob } from "@/pages/Private/redux/copywritingOrchestration/copywritingOrchestration.slice";
import { ContactProspect } from "@/pages/Private/pages/Contacts/schema/contacts";

/**
 * Maps a queue-pill job to the minimal `ContactProspect` preview the docked
 * panel opens with (P6 D6, off-page review): the job's display fields are all
 * the pill knows — the full detail loads right after (GlobalSearchModal
 * pattern), and `listPersons` carries the Chat tab's listPerson.
 */
export const generationJobToContactPreview = (job: GenerationJob): ContactProspect => {
	const [firstName, ...restOfName] = (job.personName ?? "").split(" ").filter(Boolean);

	return {
		id: job.prospectId,
		name: job.personName,
		firstName: firstName ?? null,
		lastName: restOfName.length > 0 ? restOfName.join(" ") : null,
		email: null,
		emailStatus: null,
		title: null,
		seniority: null,
		linkedinUrl: null,
		city: null,
		state: null,
		country: null,
		image: job.personAvatarUrl,
		phone: null,
		phoneStatus: null,
		headline: null,
		sentiment: null,
		gender: null,
		genderProbability: null,
		createdAt: null,
		updatedAt: null,
		organization: null,
		listPersons: [
			{
				id: job.listPersonId,
				listId: job.listId,
				updatedAt: job.generatedAt ?? job.queuedAt ?? "",
			},
		],
		lists: [{ id: job.listId, name: job.listName ?? "" }],
	};
};
